import * as React from 'react'
import SuccessSvg from '../Icons/General/Success'
import Button from '../Button/Button'
import InformationSvg from '../Icons/General/Information'
import ErrorSvg from '../Icons/General/Error'
import ToastStyles from './Toast.styles'
import CancelSvg from '../Icons/General/Cancel'

export type ToastProps = {
  variant: 'success' | 'error' | 'info',
  title: string,
  show?: boolean,
  onClose?: Function,
  action?: {
    label: string,
    onClick: (e: any) => {},
  },
  whiteBg?: boolean,
  children?: React.ReactNode
}

const Toast: React.FunctionComponent<ToastProps> = ({ variant = 'info', title, children, show = false, onClose, action, whiteBg = false }) => {
  const [isOpen, setIsOpen] = React.useState(show)
  const handleClose = (e: any) => {
    setIsOpen(false)
    /* istanbul ignore else */
    if (onClose) {
      onClose(e)
    }
  }

  const handleAction = (e: any) => {
    /* istanbul ignore else */
    if (action?.onClick) {
      action?.onClick(e)
    }
  }

  return (
    <ToastStyles className={`${variant} ${isOpen ? 'open' : ''} ${whiteBg ? 'bg-white' : ''}`}>
      <div className="left-bar" />

      <div className="toast-header">
        {variant === 'success' && <SuccessSvg />}
        {variant === 'error' && <ErrorSvg />}
        {variant === 'info' && <InformationSvg />}
        <strong>{title}</strong>
      </div>

      <div className="toast-body">
        {children}
      </div>

      <div role="button" className="close" onClick={handleClose} data-testid="close" onKeyUp={() => {}} tabIndex={0}>
        <CancelSvg />
      </div>

      {action && (
        <Button className="action" variant={Button.Variants.link} onClick={handleAction} data-testid="action">
          {action.label}
        </Button>
      )}
    </ToastStyles>
  )
}

export default Toast
